import React, { useEffect } from "react";

export default function Toast({ visible, message, type = "success", onClose }) {
  useEffect(() => {
    if (!visible) return;
    const t = setTimeout(() => {
      onClose && onClose();
    }, 4200);
    return () => clearTimeout(t);
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div className={`toast ${type}`} role="status" aria-live="polite" aria-atomic="true">
      <div className="toast-message">{message}</div>
      <button className="toast-close" onClick={onClose} aria-label="Close">×</button>
    </div>
  );
}
